import React, { createContext } from 'react';
import styled from 'styled-components';

export const RadioContext = createContext({});

const StyledFieldset = styled.fieldset`
  padding: 0;
  border: 0;
`;

const RadioGroup = ({ label, children, ...rest }) => {
  return (
    <StyledFieldset>
      <legend>{label}</legend>
      <RadioContext.Provider value={rest}>{children}</RadioContext.Provider>
    </StyledFieldset>
  );
};

export default RadioGroup;
